export const accountUpdate = '/property/account/:account';

// Account History
export const accountSelect = '/auth/select-account';
export const accountsByUser = '/account-history/api/user/:id/account';
export const accountById = '/account-history/api/account/:id';
export const accountOverview = '/account-history/account/:id/overview';
export const accountsAll = '/account-history/api/account';
export const accountProducts = '/account-history/account/:accountId/product';
export const accountUserExists = '/account-history/api/account/:id/user-exists';

// Hotels
export const getHotels = '/account-history/api/hotel';
export const getHotelByGooglePlaceId = '/account-history/api/hotel/by-google-place-id';
